module.exports = __webpack_public_path__ + "img/facebook.feb1f2a6.png";